import React, { FC } from 'react'

const FormIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 5C3 3.89543 3.89543 3 5 3H19C20.1046 3 21 3.89543 21 5V19.5C21 20.6046 20.1046 21.5 19 21.5H5C3.89543 21.5 3 20.6046 3 19.5V5ZM19 5H5V19.5H19V5ZM17 9H7V7H17V9ZM13 13H7V11H13V13ZM10 17H7V15H10V17Z'
        fill='black'
      />
    </svg>
  )
}

export default FormIcon
